// Shared drawer-refresh helper: fetches the cart-drawer section HTML,
// swaps only the drawer's inner content, updates cart-icon-bubble, and
// dispatches `cart:updated` so tier/upsell rehydrate. Safe to call from
// any component (selling plan change, discount apply, upsell add, etc.).
window.EBCartDrawerRefresh = (function () {
  function refresh() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        if (sections['cart-drawer']) {
          var drawerHtml = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = drawerHtml.querySelector('cart-drawer');
          var currentDrawer = document.querySelector('cart-drawer');
          if (newDrawer && currentDrawer) {
            // Preserve `active` class (drawer is open)
            var wasActive = currentDrawer.classList.contains('active');
            var wasAnimate = currentDrawer.classList.contains('animate');
            // Preserve is-empty flag from new render
            var isEmpty = newDrawer.classList.contains('is-empty');
            currentDrawer.className = newDrawer.className;
            if (wasActive) currentDrawer.classList.add('active');
            if (wasAnimate) currentDrawer.classList.add('animate');
            currentDrawer.classList.toggle('is-empty', isEmpty);
            // Swap inner
            var newInner = newDrawer.querySelector('.drawer__inner');
            var currentInner = currentDrawer.querySelector('.drawer__inner');
            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
            // Preserve dataset thresholds so tier JS still finds them
            ['data-tier-1-threshold', 'data-tier-2-threshold', 'data-tier-2-code'].forEach(function (attr) {
              var val = newDrawer.getAttribute(attr);
              if (val !== null) currentDrawer.setAttribute(attr, val);
            });
          }
        }
        if (sections['cart-icon-bubble']) {
          var bubbleHtml = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleHtml.querySelector('.shopify-section');
          var currentBubbleSection = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubbleSection) {
            currentBubbleSection.innerHTML = newBubble.innerHTML;
          }
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart } })
        );
        return cart;
      })
      .catch(function (err) {
        console.error('EBCartDrawerRefresh', err);
      });
  }
  return { refresh: refresh };
})();
